import _ from 'lodash'
import fp from 'lodash/fp'
import { EVENT_TYPE, UI_CODE } from '@/common/resources/const'
import { getSectionEventByType, getSectionEventObject } from '@/common/utils/gnb.fp'
import { parseUrl, stringify } from 'query-string'
import {
  API_BASE_AZURE_URL,
  API_BASE_URL,
  API_BASE_ANNEX_URL,
  API_BASE_ANNEX_AZURE_URL, API_BASE_ANNEXM_URL, API_BASE_ANNEXM_AZURE_URL, URL_GET_SEARCH_LIST, URL_POST_TAG_SEARCH_CF
} from '@/common/utils/request.const'
import {
  PATH_NAME_BASEBALL_HIGHLIGHT,
  PATH_NAME_BASEBALL_SCHEDULE,
  PATH_NAME_INSTANT_LIST, PATH_NAME_LIST,
  PATH_NAME_SEARCH,
  PATH_NAME_SEARCH_TAG,
  PATH_NAME_SEARCH_TAG_GROUP
} from '@/common/resources/router.const'
import {
  sendEventLogSearchResultEditorPickViewAll,
  sendEventLogSearchResultThemeViewAll,
  sendEventLogSearchResultViewAll
} from '@/common/utils/log.v2.send'
const TITLE = 'title'
const CELL_TYPE = 'cell_type'
// const BG_COLOR = 'bg_color'
const DEFAULT_CELL_COUNT = 20
export default {
  props: {
    sectionInfo: {
      type: Object
    }
  },
  computed: {
    multiSectionTitle () {
      return _.get(this.sectionInfo, TITLE, '')
    },
    multiSectionColor () {
      return 'background-color:#1b1b1b'
    },
    hasViewMore () {
      return fp.flow(
        fp.getOr([], 'eventlist'),
        fp.filter(event => event.type === EVENT_TYPE.ON_VIEW_MORE),
        fp.size,
        fp.thru(size => size > 0)
      )(this.sectionInfo)
    },
    hasViewAll () {
      return this.cellList.length === DEFAULT_CELL_COUNT
    },
    cellType () {
      return _.get(this.section, CELL_TYPE, '')
    },
    hasCount () {
      return Number(_.get(this.sectionInfo, 'count', '0')) > 0
    }
  },
  methods: {
    viewMoreTitle (sectionInfo, defaultTitle) {
      const { onViewMore = null, onMoveTab = null } = getSectionEventObject(_.get(sectionInfo, 'eventlist', []))
      const ifEmptyTitleThenReturnDefaultTitle = title => title === '' ? defaultTitle : title
      if (onViewMore !== null) {
        return ifEmptyTitleThenReturnDefaultTitle(_.get(onViewMore, 'title', ''))
      } else if (onMoveTab) {
        return ifEmptyTitleThenReturnDefaultTitle(_.get(onMoveTab, 'title', ''))
      }
    },
    getUiCode (onViewMore) {
      return fp.flow(
        fp.getOr('', 'url'),
        fp.thru(url => _.get(parseUrl(url), 'query', {})),
        fp.getOr('', 'uitype')
      )(onViewMore)
    },
    isApiUrl (url) {
      const targetUrl = url.indexOf('/') > 1 ? url.split('/')[0] : url
      const API_URL_LIST = [API_BASE_URL, API_BASE_AZURE_URL, API_BASE_ANNEX_URL,
        API_BASE_ANNEX_AZURE_URL, API_BASE_ANNEXM_URL, API_BASE_ANNEXM_AZURE_URL]
      return API_URL_LIST.some((baseUrl) => {
        return baseUrl.replace('https://', '').indexOf(targetUrl) > -1
      })
    },
    getPathNameByViewMore (sectionInfo) {
      const onViewMore = getSectionEventByType(EVENT_TYPE.ON_VIEW_MORE)(sectionInfo)
      const cellType = _.get(sectionInfo, 'cell_type', '')
      const { url, query } = parseUrl(_.get(onViewMore, 'url', ''))
      if (url.includes('skb/baseball/teamcalendarlist')) {
        return PATH_NAME_BASEBALL_SCHEDULE
      } else if (_.get(query, 'cliptype', '') === 'FHL' && _.get(query, 'uiparent', '').indexOf(UI_CODE.BASEBALL) > -1) {
        return PATH_NAME_BASEBALL_HIGHLIGHT
      } else if (cellType.toLowerCase() === 'band_82') {
        return PATH_NAME_INSTANT_LIST
      } else {
        return PATH_NAME_LIST
      }
    },
    getCustomQuery (onViewMore) {
      return {
        api: encodeURIComponent(onViewMore.url),
        came: this.$route.name
      }
    },
    viewMore (sectionInfo) {
      const onViewMore = getSectionEventByType(EVENT_TYPE.ON_VIEW_MORE)(sectionInfo)
      if (this.isApiUrl(onViewMore.url)) {
        this.$router.push({
          name: this.getPathNameByViewMore(sectionInfo),
          params: {
            text: _.get(sectionInfo, ['title'], ''),
            section: this.$route.name,
            url: onViewMore.url,
            uiCode: this.getUiCode(onViewMore)
          },
          query: this.getCustomQuery(onViewMore)
        })
      } else {
        let newUrl = onViewMore.url
        newUrl = newUrl.replace('captvpooq://', '')
        newUrl = newUrl.replace('http://', '')
        newUrl = newUrl.replace('https://', '')
        newUrl = newUrl.replace('www.wavve.com', '')
        newUrl = newUrl.replace('.html', '')
        this.$router.push(newUrl)
      }
    },
    viewAll (sectionInfo) {
      const IS_EDITOR_PICK = _.get(sectionInfo, 'cell_type', '') === 'titleonly'
      // editor pick 더보기
      if (IS_EDITOR_PICK) {
        const searchWord = _.get(this.$route, ['query', 'searchWord'], '')
        sendEventLogSearchResultEditorPickViewAll({ landingUrl: `${PATH_NAME_SEARCH}?${stringify({ searchWord: searchWord, category: `theme` })}` })
        this.$router.push({
          name: PATH_NAME_SEARCH,
          query: {
            searchWord: searchWord,
            category: `theme`
          }
        })
      } else {
        const onViewMore = getSectionEventByType(EVENT_TYPE.ON_VIEW_MORE)(sectionInfo)
        const { url, query } = parseUrl(onViewMore.url)
        const searchWord = _.get(query, 'keyword', '')
        const category = _.get(query, 'type', '')
        const mType = _.get(query, 'mtype', '')
        const transactionKey = _.get(query, 'transactionkey', '')
        const themeNumber = url.split('/').pop()
        this.sendRouter({
          url: url,
          searchWord: searchWord,
          category: category,
          mType: mType,
          transactionKey: transactionKey,
          themeNumber: themeNumber,
          onViewMore: onViewMore
        })
      }
    },
    sendRouter ({ url = '', searchWord = '', category = '', mType = '', transactionKey = '', themeNumber = '', onViewMore = {} }) {
      const route = { name: '', query: null, params: null }
      const IS_URL_SEARCH_VIEW = `https://${url}` === URL_GET_SEARCH_LIST
      const IS_URL_TAG_SEARCH_VIEW = (`https://${url}` === URL_POST_TAG_SEARCH_CF) && this.isTagSearchView
      const IS_URL_TAG_SEARCH_GROUP_VIEW = (`https://${url}` === URL_POST_TAG_SEARCH_CF) && this.isTagGroupSearchView

      if (IS_URL_SEARCH_VIEW) {
        route.name = PATH_NAME_SEARCH
        route.query = {
          searchWord: searchWord,
          category: category,
          mtype: mType,
          transactionkey: transactionKey
        }
        sendEventLogSearchResultViewAll({
          contentType: `${category}${mType}`,
          routeName: this.$route?.name,
          landingUrl: `${route.name}?${stringify(route.query)}`
        })
      } else if (IS_URL_TAG_SEARCH_VIEW) {
        route.name = PATH_NAME_SEARCH_TAG
        route.query = { category: category, mtype: mType, transactionkey: transactionKey }
        sendEventLogSearchResultViewAll({
          contentType: `${category}${mType}`,
          routeName: this.$route?.name,
          landingUrl: `${route.name}?${stringify(route.query)}`
        })
      } else if (IS_URL_TAG_SEARCH_GROUP_VIEW) {
        route.name = PATH_NAME_SEARCH_TAG_GROUP
        route.query = {
          tag: _.get(this.$route, 'query.tag'),
          text: _.get(this.$route, 'query.text'),
          list: category === 'movie' ? 'movie' : 'vod',
          category: category,
          mtype: mType,
          contentid: _.get(this.$route, 'query.contentid'),
          transactionkey: transactionKey
        }
        sendEventLogSearchResultViewAll({
          contentType: `${category}${mType}`,
          routeName: this.$route?.name,
          landingUrl: `${route.name}?${stringify(route.query)}`
        })
      } else {
        route.name = PATH_NAME_LIST
        route.params = { uiCode: `EN${themeNumber}` }
        route.query = {
          api: `${encodeURIComponent(onViewMore.url)}`,
          came: 'search'
        }
        sendEventLogSearchResultThemeViewAll({
          themeId: themeNumber,
          routeQuery: this.$route?.query,
          landingUrl: `${route.name}/${route.params?.uiCode}?${stringify(route.query)}`
        })
      }
      this.$router.push({
        name: route.name,
        params: route.params,
        query: route.query
      })
    }
  }
}
